/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LearnMoreImport } from './routes/learn-more'
import { Route as BookingsImport } from './routes/bookings'
import { Route as AboutImport } from './routes/about'
import { Route as IndexImport } from './routes/index'
import { Route as welcomeGiftWelcomeGiftImport } from './routes/(welcome-gift)/welcome-gift'
import { Route as menuMenuImport } from './routes/(menu)/menu'
import { Route as welcomeGiftWelcomeGiftIndexImport } from './routes/(welcome-gift)/welcome-gift.index'
import { Route as menuMenuIndexImport } from './routes/(menu)/menu.index'
import { Route as welcomeGiftWelcomeGiftResultImport } from './routes/(welcome-gift)/welcome-gift.result'
import { Route as welcomeGiftWelcomeGiftOtpImport } from './routes/(welcome-gift)/welcome-gift.otp'
import { Route as welcomeGiftWelcomeGiftErrorImport } from './routes/(welcome-gift)/welcome-gift.error'
import { Route as paymentPaymentSuccessImport } from './routes/(payment)/payment.success'
import { Route as menuMenuDiningImport } from './routes/(menu)/menu.dining'
import { Route as menuMenuDetailImport } from './routes/(menu)/menu.detail'

// Create/Update Routes

const LearnMoreRoute = LearnMoreImport.update({
  id: '/learn-more',
  path: '/learn-more',
  getParentRoute: () => rootRoute,
} as any)

const BookingsRoute = BookingsImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => rootRoute,
} as any)

const AboutRoute = AboutImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const welcomeGiftWelcomeGiftRoute = welcomeGiftWelcomeGiftImport.update({
  id: '/(welcome-gift)/welcome-gift',
  path: '/welcome-gift',
  getParentRoute: () => rootRoute,
} as any)

const menuMenuRoute = menuMenuImport.update({
  id: '/(menu)/menu',
  path: '/menu',
  getParentRoute: () => rootRoute,
} as any)

const welcomeGiftWelcomeGiftIndexRoute =
  welcomeGiftWelcomeGiftIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => welcomeGiftWelcomeGiftRoute,
  } as any)

const menuMenuIndexRoute = menuMenuIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => menuMenuRoute,
} as any)

const welcomeGiftWelcomeGiftResultRoute =
  welcomeGiftWelcomeGiftResultImport.update({
    id: '/result',
    path: '/result',
    getParentRoute: () => welcomeGiftWelcomeGiftRoute,
  } as any)

const welcomeGiftWelcomeGiftOtpRoute = welcomeGiftWelcomeGiftOtpImport.update({
  id: '/otp',
  path: '/otp',
  getParentRoute: () => welcomeGiftWelcomeGiftRoute,
} as any)

const welcomeGiftWelcomeGiftErrorRoute =
  welcomeGiftWelcomeGiftErrorImport.update({
    id: '/error',
    path: '/error',
    getParentRoute: () => welcomeGiftWelcomeGiftRoute,
  } as any)

const paymentPaymentSuccessRoute = paymentPaymentSuccessImport.update({
  id: '/(payment)/payment/success',
  path: '/payment/success',
  getParentRoute: () => rootRoute,
} as any)

const menuMenuDiningRoute = menuMenuDiningImport.update({
  id: '/dining',
  path: '/dining',
  getParentRoute: () => menuMenuRoute,
} as any)

const menuMenuDetailRoute = menuMenuDetailImport.update({
  id: '/detail',
  path: '/detail',
  getParentRoute: () => menuMenuRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutImport
      parentRoute: typeof rootRoute
    }
    '/bookings': {
      id: '/bookings'
      path: '/bookings'
      fullPath: '/bookings'
      preLoaderRoute: typeof BookingsImport
      parentRoute: typeof rootRoute
    }
    '/learn-more': {
      id: '/learn-more'
      path: '/learn-more'
      fullPath: '/learn-more'
      preLoaderRoute: typeof LearnMoreImport
      parentRoute: typeof rootRoute
    }
    '/(menu)/menu': {
      id: '/(menu)/menu'
      path: '/menu'
      fullPath: '/menu'
      preLoaderRoute: typeof menuMenuImport
      parentRoute: typeof rootRoute
    }
    '/(welcome-gift)/welcome-gift': {
      id: '/(welcome-gift)/welcome-gift'
      path: '/welcome-gift'
      fullPath: '/welcome-gift'
      preLoaderRoute: typeof welcomeGiftWelcomeGiftImport
      parentRoute: typeof rootRoute
    }
    '/(menu)/menu/detail': {
      id: '/(menu)/menu/detail'
      path: '/detail'
      fullPath: '/menu/detail'
      preLoaderRoute: typeof menuMenuDetailImport
      parentRoute: typeof menuMenuImport
    }
    '/(menu)/menu/dining': {
      id: '/(menu)/menu/dining'
      path: '/dining'
      fullPath: '/menu/dining'
      preLoaderRoute: typeof menuMenuDiningImport
      parentRoute: typeof menuMenuImport
    }
    '/(payment)/payment/success': {
      id: '/(payment)/payment/success'
      path: '/payment/success'
      fullPath: '/payment/success'
      preLoaderRoute: typeof paymentPaymentSuccessImport
      parentRoute: typeof rootRoute
    }
    '/(welcome-gift)/welcome-gift/error': {
      id: '/(welcome-gift)/welcome-gift/error'
      path: '/error'
      fullPath: '/welcome-gift/error'
      preLoaderRoute: typeof welcomeGiftWelcomeGiftErrorImport
      parentRoute: typeof welcomeGiftWelcomeGiftImport
    }
    '/(welcome-gift)/welcome-gift/otp': {
      id: '/(welcome-gift)/welcome-gift/otp'
      path: '/otp'
      fullPath: '/welcome-gift/otp'
      preLoaderRoute: typeof welcomeGiftWelcomeGiftOtpImport
      parentRoute: typeof welcomeGiftWelcomeGiftImport
    }
    '/(welcome-gift)/welcome-gift/result': {
      id: '/(welcome-gift)/welcome-gift/result'
      path: '/result'
      fullPath: '/welcome-gift/result'
      preLoaderRoute: typeof welcomeGiftWelcomeGiftResultImport
      parentRoute: typeof welcomeGiftWelcomeGiftImport
    }
    '/(menu)/menu/': {
      id: '/(menu)/menu/'
      path: '/'
      fullPath: '/menu/'
      preLoaderRoute: typeof menuMenuIndexImport
      parentRoute: typeof menuMenuImport
    }
    '/(welcome-gift)/welcome-gift/': {
      id: '/(welcome-gift)/welcome-gift/'
      path: '/'
      fullPath: '/welcome-gift/'
      preLoaderRoute: typeof welcomeGiftWelcomeGiftIndexImport
      parentRoute: typeof welcomeGiftWelcomeGiftImport
    }
  }
}

// Create and export the route tree

interface menuMenuRouteChildren {
  menuMenuDetailRoute: typeof menuMenuDetailRoute
  menuMenuDiningRoute: typeof menuMenuDiningRoute
  menuMenuIndexRoute: typeof menuMenuIndexRoute
}

const menuMenuRouteChildren: menuMenuRouteChildren = {
  menuMenuDetailRoute: menuMenuDetailRoute,
  menuMenuDiningRoute: menuMenuDiningRoute,
  menuMenuIndexRoute: menuMenuIndexRoute,
}

const menuMenuRouteWithChildren = menuMenuRoute._addFileChildren(
  menuMenuRouteChildren,
)

interface welcomeGiftWelcomeGiftRouteChildren {
  welcomeGiftWelcomeGiftErrorRoute: typeof welcomeGiftWelcomeGiftErrorRoute
  welcomeGiftWelcomeGiftOtpRoute: typeof welcomeGiftWelcomeGiftOtpRoute
  welcomeGiftWelcomeGiftResultRoute: typeof welcomeGiftWelcomeGiftResultRoute
  welcomeGiftWelcomeGiftIndexRoute: typeof welcomeGiftWelcomeGiftIndexRoute
}

const welcomeGiftWelcomeGiftRouteChildren: welcomeGiftWelcomeGiftRouteChildren =
  {
    welcomeGiftWelcomeGiftErrorRoute: welcomeGiftWelcomeGiftErrorRoute,
    welcomeGiftWelcomeGiftOtpRoute: welcomeGiftWelcomeGiftOtpRoute,
    welcomeGiftWelcomeGiftResultRoute: welcomeGiftWelcomeGiftResultRoute,
    welcomeGiftWelcomeGiftIndexRoute: welcomeGiftWelcomeGiftIndexRoute,
  }

const welcomeGiftWelcomeGiftRouteWithChildren =
  welcomeGiftWelcomeGiftRoute._addFileChildren(
    welcomeGiftWelcomeGiftRouteChildren,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/bookings': typeof BookingsRoute
  '/learn-more': typeof LearnMoreRoute
  '/menu': typeof menuMenuRouteWithChildren
  '/welcome-gift': typeof welcomeGiftWelcomeGiftRouteWithChildren
  '/menu/detail': typeof menuMenuDetailRoute
  '/menu/dining': typeof menuMenuDiningRoute
  '/payment/success': typeof paymentPaymentSuccessRoute
  '/welcome-gift/error': typeof welcomeGiftWelcomeGiftErrorRoute
  '/welcome-gift/otp': typeof welcomeGiftWelcomeGiftOtpRoute
  '/welcome-gift/result': typeof welcomeGiftWelcomeGiftResultRoute
  '/menu/': typeof menuMenuIndexRoute
  '/welcome-gift/': typeof welcomeGiftWelcomeGiftIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/bookings': typeof BookingsRoute
  '/learn-more': typeof LearnMoreRoute
  '/menu/detail': typeof menuMenuDetailRoute
  '/menu/dining': typeof menuMenuDiningRoute
  '/payment/success': typeof paymentPaymentSuccessRoute
  '/welcome-gift/error': typeof welcomeGiftWelcomeGiftErrorRoute
  '/welcome-gift/otp': typeof welcomeGiftWelcomeGiftOtpRoute
  '/welcome-gift/result': typeof welcomeGiftWelcomeGiftResultRoute
  '/menu': typeof menuMenuIndexRoute
  '/welcome-gift': typeof welcomeGiftWelcomeGiftIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/bookings': typeof BookingsRoute
  '/learn-more': typeof LearnMoreRoute
  '/(menu)/menu': typeof menuMenuRouteWithChildren
  '/(welcome-gift)/welcome-gift': typeof welcomeGiftWelcomeGiftRouteWithChildren
  '/(menu)/menu/detail': typeof menuMenuDetailRoute
  '/(menu)/menu/dining': typeof menuMenuDiningRoute
  '/(payment)/payment/success': typeof paymentPaymentSuccessRoute
  '/(welcome-gift)/welcome-gift/error': typeof welcomeGiftWelcomeGiftErrorRoute
  '/(welcome-gift)/welcome-gift/otp': typeof welcomeGiftWelcomeGiftOtpRoute
  '/(welcome-gift)/welcome-gift/result': typeof welcomeGiftWelcomeGiftResultRoute
  '/(menu)/menu/': typeof menuMenuIndexRoute
  '/(welcome-gift)/welcome-gift/': typeof welcomeGiftWelcomeGiftIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/bookings'
    | '/learn-more'
    | '/menu'
    | '/welcome-gift'
    | '/menu/detail'
    | '/menu/dining'
    | '/payment/success'
    | '/welcome-gift/error'
    | '/welcome-gift/otp'
    | '/welcome-gift/result'
    | '/menu/'
    | '/welcome-gift/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/bookings'
    | '/learn-more'
    | '/menu/detail'
    | '/menu/dining'
    | '/payment/success'
    | '/welcome-gift/error'
    | '/welcome-gift/otp'
    | '/welcome-gift/result'
    | '/menu'
    | '/welcome-gift'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/bookings'
    | '/learn-more'
    | '/(menu)/menu'
    | '/(welcome-gift)/welcome-gift'
    | '/(menu)/menu/detail'
    | '/(menu)/menu/dining'
    | '/(payment)/payment/success'
    | '/(welcome-gift)/welcome-gift/error'
    | '/(welcome-gift)/welcome-gift/otp'
    | '/(welcome-gift)/welcome-gift/result'
    | '/(menu)/menu/'
    | '/(welcome-gift)/welcome-gift/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  BookingsRoute: typeof BookingsRoute
  LearnMoreRoute: typeof LearnMoreRoute
  menuMenuRoute: typeof menuMenuRouteWithChildren
  welcomeGiftWelcomeGiftRoute: typeof welcomeGiftWelcomeGiftRouteWithChildren
  paymentPaymentSuccessRoute: typeof paymentPaymentSuccessRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  BookingsRoute: BookingsRoute,
  LearnMoreRoute: LearnMoreRoute,
  menuMenuRoute: menuMenuRouteWithChildren,
  welcomeGiftWelcomeGiftRoute: welcomeGiftWelcomeGiftRouteWithChildren,
  paymentPaymentSuccessRoute: paymentPaymentSuccessRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/about",
        "/bookings",
        "/learn-more",
        "/(menu)/menu",
        "/(welcome-gift)/welcome-gift",
        "/(payment)/payment/success"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/about": {
      "filePath": "about.tsx"
    },
    "/bookings": {
      "filePath": "bookings.tsx"
    },
    "/learn-more": {
      "filePath": "learn-more.tsx"
    },
    "/(menu)/menu": {
      "filePath": "(menu)/menu.tsx",
      "children": [
        "/(menu)/menu/detail",
        "/(menu)/menu/dining",
        "/(menu)/menu/"
      ]
    },
    "/(welcome-gift)/welcome-gift": {
      "filePath": "(welcome-gift)/welcome-gift.tsx",
      "children": [
        "/(welcome-gift)/welcome-gift/error",
        "/(welcome-gift)/welcome-gift/otp",
        "/(welcome-gift)/welcome-gift/result",
        "/(welcome-gift)/welcome-gift/"
      ]
    },
    "/(menu)/menu/detail": {
      "filePath": "(menu)/menu.detail.tsx",
      "parent": "/(menu)/menu"
    },
    "/(menu)/menu/dining": {
      "filePath": "(menu)/menu.dining.tsx",
      "parent": "/(menu)/menu"
    },
    "/(payment)/payment/success": {
      "filePath": "(payment)/payment.success.tsx"
    },
    "/(welcome-gift)/welcome-gift/error": {
      "filePath": "(welcome-gift)/welcome-gift.error.tsx",
      "parent": "/(welcome-gift)/welcome-gift"
    },
    "/(welcome-gift)/welcome-gift/otp": {
      "filePath": "(welcome-gift)/welcome-gift.otp.tsx",
      "parent": "/(welcome-gift)/welcome-gift"
    },
    "/(welcome-gift)/welcome-gift/result": {
      "filePath": "(welcome-gift)/welcome-gift.result.tsx",
      "parent": "/(welcome-gift)/welcome-gift"
    },
    "/(menu)/menu/": {
      "filePath": "(menu)/menu.index.tsx",
      "parent": "/(menu)/menu"
    },
    "/(welcome-gift)/welcome-gift/": {
      "filePath": "(welcome-gift)/welcome-gift.index.tsx",
      "parent": "/(welcome-gift)/welcome-gift"
    }
  }
}
ROUTE_MANIFEST_END */
